// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.bs.js");
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var FormControl = require("@mui/material/FormControl").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function stmtMayMatchAsrt(stmt, frm, parenCnt) {
  if (Caml_array.get(stmt, 0) !== Caml_array.get(frm.frame.asrt, 0)) {
    return false;
  }
  var res = {
    contents: false
  };
  MM_substitution.iterateSubstitutions(frm.frame.asrt, stmt, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, parenCnt, (function (param) {
          res.contents = true;
          return /* Stop */1;
        }));
  return res.contents;
}

function getAvailableAsrtLabels(frms, parenCnt, stmtToProve) {
  var availableAsrtLabels = [];
  Belt_MapString.forEach(frms, (function (label, frm) {
          if (stmtMayMatchAsrt(stmtToProve, frm, parenCnt)) {
            availableAsrtLabels.push(label);
            return ;
          }
          
        }));
  return availableAsrtLabels;
}

function makeInitialState(userStmtToProve, stmts, frms, parenCnt) {
  var stmtToProve = Caml_array.get(stmts, stmts.length - 1 | 0).expr;
  return {
          title: React.createElement("span", undefined, React.createElement("span", {
                    style: {
                      fontWeight: "bold"
                    }
                  }, "Proving bottom-up "), MM_cmp_user_stmt.rndContText(userStmtToProve.cont)),
          availableLabels: getAvailableAsrtLabels(frms, parenCnt, stmtToProve),
          label: undefined,
          depth: 4,
          depthStr: "4",
          lengthRestrict: /* Less */2,
          allowNewVars: true,
          results: undefined,
          resultsRendered: undefined,
          sortBy: /* UnprovedStmtsNum */0,
          resultsSorted: undefined,
          resultsPerPage: 20,
          resultsMaxPage: 0,
          resultsPage: 0,
          checkedResultIdx: undefined
        };
}

function setLabel(st, label) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: st.resultsSorted,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultIdx: st.checkedResultIdx
        };
}

function setDepthStr(st, depthStr) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: st.resultsSorted,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultIdx: st.checkedResultIdx
        };
}

function setLengthRestrict(st, lengthRestrict) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: st.resultsSorted,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultIdx: st.checkedResultIdx
        };
}

function toggleAllowNewVars(st) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: !st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: st.resultsSorted,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultIdx: st.checkedResultIdx
        };
}

function newStmtsDtoToResultRendered(newStmtsDto, idx) {
  var elem = React.createElement(Expln_React_Column.make, {
        children: null
      }, newStmtsDto.newDisjStr.map(function (disjStr) {
            return React.createElement("span", {
                        key: disjStr
                      }, disjStr);
          }), React.createElement("table", undefined, React.createElement("tbody", undefined, newStmtsDto.stmts.map(function (stmt) {
                    var match = stmt.jstf;
                    return React.createElement("tr", {
                                key: stmt.exprStr
                              }, React.createElement("td", undefined, stmt.label), React.createElement("td", {
                                    style: {
                                      textAlign: "right"
                                    }
                                  }, match !== undefined ? "[" + match.args.join(" ") + " : " + match.label + " ]" : null), React.createElement("td", {
                                    style: {
                                      color: stmt.isProved ? "green" : "#565656",
                                      fontWeight: "bold"
                                    }
                                  }, stmt.isProved ? "\u2713" : "?"), React.createElement("td", undefined, stmt.exprStr));
                  }))));
  return {
          idx: idx,
          elem: elem,
          isProved: Caml_array.get(newStmtsDto.stmts, newStmtsDto.stmts.length - 1 | 0).isProved,
          asrtLabel: Belt_Option.getWithDefault(Belt_Option.map(Caml_array.get(newStmtsDto.stmts, newStmtsDto.stmts.length - 1 | 0).jstf, (function (jstf) {
                      return jstf.label;
                    })), ""),
          numOfNewVars: newStmtsDto.newVars.length,
          numOfNewUnprovedStmts: newStmtsDto.stmts.reduce((function (cnt, stmt) {
                  return cnt + (
                          stmt.isProved ? 0 : 1
                        ) | 0;
                }), 0),
          numOfStmts: newStmtsDto.stmts.length
        };
}

function compareByIsProved(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                if (res.isProved) {
                  return 0;
                } else {
                  return 1;
                }
              }), param, param$1);
}

function compareByNumberOfStmts(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfStmts;
              }), param, param$1);
}

function compareByNumOfNewUnprovedStmts(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfNewUnprovedStmts;
              }), param, param$1);
}

function compareByNumOfNewVars(param, param$1) {
  return Expln_utils_common.comparatorBy((function (res) {
                return res.numOfNewVars;
              }), param, param$1);
}

function compareByAsrtLabel(a, b) {
  return a.asrtLabel.localeCompare(b.asrtLabel) | 0;
}

function createComparator(sortBy) {
  var mainCmp;
  switch (sortBy) {
    case /* UnprovedStmtsNum */0 :
        mainCmp = compareByNumOfNewUnprovedStmts;
        break;
    case /* NumOfNewVars */1 :
        mainCmp = compareByNumOfNewVars;
        break;
    case /* AsrtLabel */2 :
        mainCmp = compareByAsrtLabel;
        break;
    
  }
  return function (param, param$1) {
    return Expln_utils_common.comparatorAndThen((function (param, param$1) {
                  return Expln_utils_common.comparatorAndThen((function (param, param$1) {
                                return Expln_utils_common.comparatorAndThen(compareByIsProved, mainCmp, param, param$1);
                              }), compareByNumberOfStmts, param, param$1);
                }), compareByAsrtLabel, param, param$1);
  };
}

function sortResultsRendered(resultsRendered, sortBy) {
  if (resultsRendered !== undefined) {
    return resultsRendered.slice().sort(createComparator(sortBy));
  }
  
}

function setResults(st, results) {
  if (results === undefined) {
    return {
            title: st.title,
            availableLabels: st.availableLabels,
            label: st.label,
            depth: st.depth,
            depthStr: st.depthStr,
            lengthRestrict: st.lengthRestrict,
            allowNewVars: st.allowNewVars,
            results: results,
            resultsRendered: undefined,
            sortBy: st.sortBy,
            resultsSorted: undefined,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: 0,
            resultsPage: 0,
            checkedResultIdx: undefined
          };
  }
  var resultsRendered = results.map(newStmtsDtoToResultRendered);
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: results,
          resultsRendered: resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: sortResultsRendered(resultsRendered, st.sortBy),
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: Js_math.ceil_int(results.length / st.resultsPerPage),
          resultsPage: 1,
          checkedResultIdx: undefined
        };
}

function setSortBy(st, sortBy) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: sortBy,
          resultsSorted: sortResultsRendered(st.resultsRendered, sortBy),
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: 1,
          checkedResultIdx: undefined
        };
}

function setPage(st, page) {
  return {
          title: st.title,
          availableLabels: st.availableLabels,
          label: st.label,
          depth: st.depth,
          depthStr: st.depthStr,
          lengthRestrict: st.lengthRestrict,
          allowNewVars: st.allowNewVars,
          results: st.results,
          resultsRendered: st.resultsRendered,
          sortBy: st.sortBy,
          resultsSorted: st.resultsSorted,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: page,
          checkedResultIdx: st.checkedResultIdx
        };
}

function toggleResultChecked(st, idx) {
  var checkedIdx = st.checkedResultIdx;
  if (checkedIdx !== undefined && checkedIdx === idx) {
    return {
            title: st.title,
            availableLabels: st.availableLabels,
            label: st.label,
            depth: st.depth,
            depthStr: st.depthStr,
            lengthRestrict: st.lengthRestrict,
            allowNewVars: st.allowNewVars,
            results: st.results,
            resultsRendered: st.resultsRendered,
            sortBy: st.sortBy,
            resultsSorted: st.resultsSorted,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultIdx: undefined
          };
  } else {
    return {
            title: st.title,
            availableLabels: st.availableLabels,
            label: st.label,
            depth: st.depth,
            depthStr: st.depthStr,
            lengthRestrict: st.lengthRestrict,
            allowNewVars: st.allowNewVars,
            results: st.results,
            resultsRendered: st.resultsRendered,
            sortBy: st.sortBy,
            resultsSorted: st.resultsSorted,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultIdx: idx
          };
  }
}

var notDigitPattern = /\D/g;

function lengthRestrictToStr(len) {
  switch (len) {
    case /* No */0 :
        return "No";
    case /* LessEq */1 :
        return "LessEq";
    case /* Less */2 :
        return "Less";
    
  }
}

function lengthRestrictFromStr(str) {
  switch (str) {
    case "Less" :
        return /* Less */2;
    case "LessEq" :
        return /* LessEq */1;
    case "No" :
        return /* No */0;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to lengthRestrict."
            },
            Error: new Error()
          };
  }
}

function sortByToStr(sortBy) {
  switch (sortBy) {
    case /* UnprovedStmtsNum */0 :
        return "UnprovedStmtsNum";
    case /* NumOfNewVars */1 :
        return "NumOfNewVars";
    case /* AsrtLabel */2 :
        return "AsrtLabel";
    
  }
}

function sortByFromStr(str) {
  switch (str) {
    case "AsrtLabel" :
        return /* AsrtLabel */2;
    case "NumOfNewVars" :
        return /* NumOfNewVars */1;
    case "UnprovedStmtsNum" :
        return /* UnprovedStmtsNum */0;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert value of '" + str + "' to a sortBy."
            },
            Error: new Error()
          };
  }
}

function MM_cmp_unify_bottom_up(Props) {
  var modalRef = Props.modalRef;
  var preCtxVer = Props.preCtxVer;
  var preCtx = Props.preCtx;
  var frms = Props.frms;
  var parenCnt = Props.parenCnt;
  var wrkCtx = Props.wrkCtx;
  var parenStr = Props.parenStr;
  var varsText = Props.varsText;
  var disjText = Props.disjText;
  var hyps = Props.hyps;
  var userStmtToProve = Props.userStmtToProve;
  var stmts = Props.stmts;
  var typeToPrefix = Props.typeToPrefix;
  var onResultSelected = Props.onResultSelected;
  var onCancel = Props.onCancel;
  var match = React.useState(function () {
        return makeInitialState(userStmtToProve, stmts, frms, parenCnt);
      });
  var setState = match[1];
  var state = match[0];
  var results = state.results;
  var onlyOneResultIsAvailable = results !== undefined ? results.length === 1 : false;
  var actLabelUpdated = function (label) {
    Curry._1(setState, (function (__x) {
            return setLabel(__x, label);
          }));
  };
  var actDepthUpdated = function (depthStr) {
    Curry._1(setState, (function (__x) {
            return setDepthStr(__x, depthStr.replace(notDigitPattern, ""));
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var rndLengthRestrictSelector = function (value) {
    return React.createElement(FormControl, {
                size: "small",
                children: null
              }, React.createElement(InputLabel, {
                    id: "length-restrict-select-label",
                    children: "Length restriction"
                  }), React.createElement(Select, {
                    sx: {
                      width: 130
                    },
                    labelId: "length-restrict-select-label",
                    label: "Length restriction",
                    value: lengthRestrictToStr(value),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      var lengthRestrict = lengthRestrictFromStr(str);
                                      Curry._1(setState, (function (__x) {
                                              return setLengthRestrict(__x, lengthRestrict);
                                            }));
                                    }), param);
                      }),
                    children: null
                  }, React.createElement(MenuItem, {
                        value: "No",
                        children: "No"
                      }), React.createElement(MenuItem, {
                        value: "LessEq",
                        children: "LessEq"
                      }), React.createElement(MenuItem, {
                        value: "Less",
                        children: "Less"
                      })));
  };
  var rndSortBySelector = function (param) {
    var results = state.results;
    if (results !== undefined && results.length >= 2) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: null
                }, React.createElement(InputLabel, {
                      id: "sortBy-select-label",
                      children: "Sort results by"
                    }), React.createElement(Select, {
                      labelId: "sortBy-select-label",
                      label: "Sort results by",
                      value: sortByToStr(state.sortBy),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        var sortBy = sortByFromStr(str);
                                        Curry._1(setState, (function (__x) {
                                                return setSortBy(__x, sortBy);
                                              }));
                                      }), param);
                        }),
                      children: null
                    }, React.createElement(MenuItem, {
                          value: "UnprovedStmtsNum",
                          children: "Number of new unproved statements"
                        }), React.createElement(MenuItem, {
                          value: "NumOfNewVars",
                          children: "Number of new variables"
                        }), React.createElement(MenuItem, {
                          value: "AsrtLabel",
                          children: "Assertion label"
                        })));
    } else {
      return null;
    }
  };
  var rndParams = function (param) {
    if (state.availableLabels.length === 0) {
      return React.createElement(Expln_React_Column.make, {
                  children: null
                }, "The statement to prove doesn't math any existing assertion. Bottom-up proving is not available for such statements.", React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(onCancel, undefined);
                        }),
                      children: "Ok"
                    }));
    } else {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(AutocompleteVirtualized.make, {
                      value: state.label,
                      options: state.availableLabels,
                      onChange: actLabelUpdated,
                      size: "small",
                      width: 200
                    }), React.createElement(TextField, {
                      value: state.depthStr,
                      label: "Search depth",
                      size: "small",
                      style: {
                        width: "100px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actDepthUpdated, param);
                        }),
                      autoFocus: true
                    }), rndLengthRestrictSelector(state.lengthRestrict), React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: state.allowNewVars,
                            onChange: (function (param) {
                                Curry._1(setState, toggleAllowNewVars);
                              })
                          }),
                      label: "Allow new variables"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(setState, (function (st) {
                                  var depthStr = st.depthStr.trim();
                                  var st$1;
                                  if (depthStr.length === 0) {
                                    st$1 = {
                                      title: st.title,
                                      availableLabels: st.availableLabels,
                                      label: st.label,
                                      depth: 1,
                                      depthStr: "1",
                                      lengthRestrict: st.lengthRestrict,
                                      allowNewVars: st.allowNewVars,
                                      results: st.results,
                                      resultsRendered: st.resultsRendered,
                                      sortBy: st.sortBy,
                                      resultsSorted: st.resultsSorted,
                                      resultsPerPage: st.resultsPerPage,
                                      resultsMaxPage: st.resultsMaxPage,
                                      resultsPage: st.resultsPage,
                                      checkedResultIdx: st.checkedResultIdx
                                    };
                                  } else {
                                    var depth = Math.max(Belt_Option.getWithDefault(Belt_Int.fromString(depthStr), 1), 1);
                                    var depthStr$1 = String(depth);
                                    st$1 = {
                                      title: st.title,
                                      availableLabels: st.availableLabels,
                                      label: st.label,
                                      depth: depth,
                                      depthStr: depthStr$1,
                                      lengthRestrict: st.lengthRestrict,
                                      allowNewVars: st.allowNewVars,
                                      results: st.results,
                                      resultsRendered: st.resultsRendered,
                                      sortBy: st.sortBy,
                                      resultsSorted: st.resultsSorted,
                                      resultsPerPage: st.resultsPerPage,
                                      resultsMaxPage: st.resultsMaxPage,
                                      resultsPage: st.resultsPage,
                                      checkedResultIdx: st.checkedResultIdx
                                    };
                                  }
                                  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                              return MM_react_common.rndProgress("Proving bottom-up", 0, undefined, undefined);
                                            })), (function (modalId) {
                                          Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                  return MM_react_common.rndProgress("Proving bottom-up", 0, (function (param) {
                                                                return makeActTerminate(modalId, param);
                                                              }), undefined);
                                                }));
                                          return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, stmts, {
                                                          asrtLabel: st$1.label,
                                                          maxSearchDepth: st$1.depth,
                                                          lengthRestriction: st$1.lengthRestrict,
                                                          allowNewVars: st$1.allowNewVars
                                                        }, (function (msg) {
                                                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                                    return MM_react_common.rndProgress(msg, undefined, (function (param) {
                                                                                  return makeActTerminate(modalId, param);
                                                                                }), undefined);
                                                                  }));
                                                          })), (function (proofTreeDto) {
                                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                                        var results = MM_wrk_unify.proofTreeDtoToNewStmtsDto(proofTreeDto, stmts, wrkCtx, typeToPrefix);
                                                        Curry._1(setState, (function (__x) {
                                                                return setResults(__x, results);
                                                              }));
                                                      }));
                                        }));
                                  return st$1;
                                }));
                        }),
                      variant: "outlined",
                      children: "Prove"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(onCancel, undefined);
                        }),
                      children: "Cancel"
                    }));
    }
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      Curry._1(setState, (function (__x) {
                              return setPage(__x, newPage);
                            }));
                    })
                });
    } else {
      return null;
    }
  };
  var rndApplyButton = function (param) {
    return React.createElement(Button, {
                onClick: (function (param) {
                    var results = state.results;
                    if (results === undefined) {
                      return ;
                    }
                    if (onlyOneResultIsAvailable) {
                      return Curry._1(onResultSelected, Caml_array.get(results, 0));
                    }
                    var checkedResultIdx = state.checkedResultIdx;
                    if (checkedResultIdx !== undefined) {
                      return Curry._1(onResultSelected, Caml_array.get(results, checkedResultIdx));
                    }
                    
                  }),
                variant: "contained",
                disabled: !onlyOneResultIsAvailable && Belt_Option.isNone(state.checkedResultIdx),
                children: onlyOneResultIsAvailable ? "Apply" : "Apply selected"
              });
  };
  var rndResults = function (param) {
    var resultsSorted = state.resultsSorted;
    if (resultsSorted === undefined) {
      return null;
    }
    var totalNumOfResults = resultsSorted.length;
    if (totalNumOfResults === 0) {
      return "Nothing found.";
    }
    var start = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
    var items = resultsSorted.slice(start, start + state.resultsPerPage | 0);
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: null
                  }, rndApplyButton(undefined), rndSortBySelector(undefined), rndPagination(totalNumOfResults)), items.map(function (item) {
                    return React.createElement("table", {
                                key: String(item.idx)
                              }, React.createElement("tbody", undefined, React.createElement("tr", undefined, onlyOneResultIsAvailable ? null : React.createElement("td", undefined, React.createElement(Checkbox, {
                                                  checked: Belt_Option.getWithDefault(Belt_Option.map(state.checkedResultIdx, (function (idx) {
                                                              return idx === item.idx;
                                                            })), false),
                                                  onChange: (function (param) {
                                                      var idx = item.idx;
                                                      Curry._1(setState, (function (__x) {
                                                              return toggleResultChecked(__x, idx);
                                                            }));
                                                    })
                                                })), React.createElement("td", undefined, React.createElement(Paper, {
                                                children: item.elem
                                              })))));
                  }), rndPagination(totalNumOfResults), rndApplyButton(undefined));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1.5,
                    children: null
                  }, state.title, rndParams(undefined), rndResults(undefined))
            });
}

var make = MM_cmp_unify_bottom_up;

exports.stmtMayMatchAsrt = stmtMayMatchAsrt;
exports.getAvailableAsrtLabels = getAvailableAsrtLabels;
exports.makeInitialState = makeInitialState;
exports.setLabel = setLabel;
exports.setDepthStr = setDepthStr;
exports.setLengthRestrict = setLengthRestrict;
exports.toggleAllowNewVars = toggleAllowNewVars;
exports.newStmtsDtoToResultRendered = newStmtsDtoToResultRendered;
exports.compareByIsProved = compareByIsProved;
exports.compareByNumberOfStmts = compareByNumberOfStmts;
exports.compareByNumOfNewUnprovedStmts = compareByNumOfNewUnprovedStmts;
exports.compareByNumOfNewVars = compareByNumOfNewVars;
exports.compareByAsrtLabel = compareByAsrtLabel;
exports.createComparator = createComparator;
exports.sortResultsRendered = sortResultsRendered;
exports.setResults = setResults;
exports.setSortBy = setSortBy;
exports.setPage = setPage;
exports.toggleResultChecked = toggleResultChecked;
exports.notDigitPattern = notDigitPattern;
exports.lengthRestrictToStr = lengthRestrictToStr;
exports.lengthRestrictFromStr = lengthRestrictFromStr;
exports.sortByToStr = sortByToStr;
exports.sortByFromStr = sortByFromStr;
exports.make = make;
/* react Not a pure module */
